export const isTournamentEliminationNotification = (data: any): boolean => {
    const notificationType = typeof data?.type === 'string' ? data.type.toUpperCase() : '';
    return data?.isEliminationMessage === true ||
        notificationType === 'TOURNAMENT_ELIMINATED' ||
        data?.messageKey === 'tournament.eliminated';
};

const stringId = (value: any): string | undefined => {
    return typeof value === 'string' && value.length > 0 ? value : undefined;
};

export const getTournamentEliminationIds = (data: any) => {
    const roomId = stringId(data?.roomId);
    const tournamentGameId = stringId(data?.tournamentGameId) || stringId(data?.tournamentId);
    const tournamentId = stringId(data?.tournamentId) || tournamentGameId;

    return { roomId, tournamentGameId, tournamentId };
};

export const doesTournamentEliminationStatusMatchRoom = (room: any, data: any): boolean => {
    const { roomId, tournamentGameId, tournamentId } = getTournamentEliminationIds(data);
    if (!roomId && !tournamentGameId && !tournamentId) return false;

    const incomingTournamentIds = [tournamentGameId, tournamentId].filter((id): id is string => typeof id === 'string' && id.length > 0);
    const roomTournamentIds = [room?.tournamentGameId, room?.tournamentId, room?.gameId, room?.gameId_]
        .filter((id): id is string => typeof id === 'string' && id.length > 0);
    const matchesRoomId = Boolean(roomId && room?.roomId === roomId);
    const matchesTournament =
        incomingTournamentIds.length > 0 &&
        roomTournamentIds.some((id) => incomingTournamentIds.includes(id));

    return matchesRoomId || matchesTournament;
};

export const applyTournamentEliminationStatusToRoom = (
    room: any,
    data: any,
    options: {
        notificationTimestamp: number;
        buildMessage: (room: any) => string;
    }
): { room: any; matched: boolean; changed: boolean } => {
    if (!doesTournamentEliminationStatusMatchRoom(room, data)) {
        return { room, matched: false, changed: false };
    }

    const { tournamentGameId, tournamentId } = getTournamentEliminationIds(data);
    const eliminated = Boolean(data?.eliminated);
    const eliminationTime = typeof data?.eliminationTime === 'string' ? data.eliminationTime : null;
    const position = typeof data?.position === 'number' ? data.position : null;
    let changed = false;
    const next: any = { ...room };

    if (next.isTournamentTable !== true) {
        next.isTournamentTable = true;
        changed = true;
    }
    if (tournamentGameId && next.tournamentGameId !== tournamentGameId) {
        next.tournamentGameId = tournamentGameId;
        changed = true;
    }
    if (tournamentId && next.tournamentId !== tournamentId) {
        next.tournamentId = tournamentId;
        changed = true;
    }
    if (next.tournamentEliminated !== eliminated) {
        next.tournamentEliminated = eliminated;
        changed = true;
    }
    if ((next.tournamentEliminationTime ?? null) !== eliminationTime) {
        next.tournamentEliminationTime = eliminationTime;
        changed = true;
    }
    if (position !== null && (next.tournamentPosition ?? null) !== position) {
        next.tournamentPosition = position;
        changed = true;
    }
    if (eliminated) {
        const message = options.buildMessage(next);
        const existingPending = next.pendingNotification;
        const alreadyPendingSameElimination =
            existingPending?.type === 'TOURNAMENT_ELIMINATED' &&
            existingPending?.message === message;

        if (!alreadyPendingSameElimination) {
            next.pendingNotification = {
                message,
                type: 'TOURNAMENT_ELIMINATED',
                timestamp: options.notificationTimestamp
            };
            changed = true;
        }
    }

    return { room: next, matched: true, changed };
};
